<template>
  <div class="br-amount form-input --data-format-left" data-format="$">
    <label class="form-label" data-tool-tip="true">
      <info-icon></info-icon>
    </label>
    <input
      name="amount"
      data-ri-filtername="amount"
      data-ri-filtervalue="[name='amount']"
      v-model="value"
      v-on:focus="selectAll"
      v-on:keyup.enter="updateAmount($event.target.value)"
      v-on:keyup="maskComma"
      v-on:blur="validateAmount($event.target.value)"
      class="gearbox-input"
      data-cy="amount"
    />
    <span class="error-message">{{ error }}</span>
  </div>
</template>

<script>
import eventHub from '../bankrate-events/index'
import utils from '../../bankrate-utilities/index'
import infoIcon from './rt-info.vue'

// @DEPRECATED - Rewrite or clean up for any future use
export default {
  components: {
    'info-icon': infoIcon
  },

  props: {
    defaultValue: {
      type: Number
    },
    minValue: {
      type: Number
    },
    maxValue: {
      type: Number
    },
    title: {
      type: String
    },
    copy: {
      type: Array
    },
    error: {
      type: String
    }
  },

  data: function() {
    return {
      value: '',
      lastValue: ''
    }
  },

  created: function() {
    this.value = this.defaultValue
  },

  mounted: function() {
    this.$nextTick(function() {
      if (utils.isDesktop()) {
        this.maskComma({
          target: this.$el.querySelector('input')
        })
      }
      eventHub.$emit('rateTable::setDepositAmount', this.defaultValue)
      this.lastValue = this.defaultValue.toString()
    })
  },

  methods: {
    cleanValue: function(value) {
      return value.replace(/\D/g, '')
    },

    updateAmount: function(value) {
      let cleanedValue = this.cleanValue(value)

      // NO errors and different value
      if (!this.hasDisplayError(value) && this.lastValue !== cleanedValue) {
        this.value = cleanedValue

        if (utils.isValidForm()) {
          eventHub.$emit('updateAmount', this.value)
          eventHub.$emit('rateTable::setDepositAmount', this.value)
          this.$emit('input', this.value || null)
        }
      }

      this.lastValue = cleanedValue
    },

    validateAmount: function(value) {
      if (this.lastValue !== this.cleanValue(value)) {
        this.updateAmount(value)
      }
    },

    maskComma: function(event) {
      if (event !== undefined) {
        if (event.which >= 37 && event.which <= 40) {
          return
        }
      }
      this.hasDisplayError(event.target.value)

      // Replace non-digits, add in comma format
      event.target.value = event.target.value
        .replace(/^0+/, '')
        .replace(/\D/g, '')
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    hasDisplayError: function(value) {
      value = value.replace(/\D/g, '')
      if (value < this.minValue || value > this.maxValue) {
        if (!this.$el.classList.contains('--has-error')) {
          this.$el.classList.add('--has-error')
        }
        return true
      } else {
        this.$el.classList.remove('--has-error')
        return false
      }
    },

    selectAll: function(event) {
      // Workaround for Safari bug
      // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
      setTimeout(function() {
        event.target.select()
      }, 0)
    }
  }
}
</script>
